import { ApiResource } from "./apiResource";
import { ApiDataResponse } from "../apiClient";

type ClinicsConfigsData = {
  codeName: string;
  codeValue: string;
  createdAt: string;
  groupName: string;
  id: number;
  order: null | number;
  updatedAt: string;
};

export class ClinicsApi extends ApiResource {
  async getClinic(clinicId: string) {
    return this.client.get<ApiDataResponse<any>>(`/clinics/${clinicId}`);
  }

  async getConfigs(params?: { groupName: string; codeName: string }) {
    return this.client.get<ApiDataResponse<ClinicsConfigsData[]>>(
      `/clinics/configs`,
      {
        params,
      }
    );
  }

  async getClinicDrive(clinicId: string) {
    return this.client.get<ApiDataResponse<any>>(`/drives/clinics/${clinicId}`);
  }

  async getHolidays(params: any) {
    return this.client.get<ApiDataResponse<any>>("/holidays", {
      params,
    });
  }

  async getExternalLinkedChannel() {
    return this.client.get<ApiDataResponse<any>>("/external_linked/channels");
  }
}
